"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./BoxClosedBy"), exports);
__exportStar(require("./BoxStatus"), exports);
__exportStar(require("./ConditionMinimal"), exports);
__exportStar(require("./Dimensions"), exports);
__exportStar(require("./DisposalSummary"), exports);
__exportStar(require("./Disposition"), exports);
__exportStar(require("./DispositionStatus"), exports);
__exportStar(require("./FulfillmentOrder"), exports);
__exportStar(require("./FulfillmentOrderLabel"), exports);
__exportStar(require("./FulfillmentShipment"), exports);
__exportStar(require("./ImageCreate"), exports);
__exportStar(require("./ImageMinimal"), exports);
__exportStar(require("./InspectionConfig"), exports);
__exportStar(require("./InspectionNotesUpdate"), exports);
__exportStar(require("./InspectionRules"), exports);
__exportStar(require("./MerchantReturnProgramResponse"), exports);
__exportStar(require("./ParcelReturnOrderCreate"), exports);
__exportStar(require("./ProductIdentifiers"), exports);
__exportStar(require("./ProductMinimal"), exports);
__exportStar(require("./QcItemStatus"), exports);
__exportStar(require("./QcLookup"), exports);
__exportStar(require("./QcPackageCreate"), exports);
__exportStar(require("./QcPackageMinimal"), exports);
__exportStar(require("./QcPackageReturnOrderCreate"), exports);
__exportStar(require("./QcReturnItemMinimal"), exports);
__exportStar(require("./RefundSource"), exports);
__exportStar(require("./RefundStatus"), exports);
__exportStar(require("./RequestSource"), exports);
__exportStar(require("./ReturnAddress"), exports);
__exportStar(require("./ReturnItemIdentificationRequest"), exports);
__exportStar(require("./ReturnItemIdentificationResponse"), exports);
__exportStar(require("./ReturnItemInspectionRequest"), exports);
__exportStar(require("./ReturnItemInspectionResponse"), exports);
__exportStar(require("./ReturnItemMinimal"), exports);
__exportStar(require("./ReturnLabelMinimal"), exports);
__exportStar(require("./ReturnLabelSource"), exports);
__exportStar(require("./ReturnOrderArrivedRequest"), exports);
__exportStar(require("./ReturnOrderCreate"), exports);
__exportStar(require("./ReturnOrderIdentificationRequest"), exports);
__exportStar(require("./ReturnOrderIdentificationResponse"), exports);
__exportStar(require("./ReturnOrderMinimal"), exports);
__exportStar(require("./ReturnOrderRow"), exports);
__exportStar(require("./ReturnOrdersPage"), exports);
__exportStar(require("./ReturnPackageMinimal"), exports);
__exportStar(require("./ReturnProgramType"), exports);
__exportStar(require("./ReturnStatus"), exports);
__exportStar(require("./ReturnType"), exports);
__exportStar(require("./RMT"), exports);
__exportStar(require("./RmtAccessKey"), exports);
__exportStar(require("./RmtId"), exports);
__exportStar(require("./RTSReturnOrderCreate"), exports);
__exportStar(require("./SellerAddress"), exports);
__exportStar(require("./SellerCreate"), exports);
__exportStar(require("./SellerDispositionMinimal"), exports);
__exportStar(require("./SellerDispositionUpdate"), exports);
__exportStar(require("./SellerMinimal"), exports);
__exportStar(require("./SellerProgramMinimal"), exports);
__exportStar(require("./SellerRmtCreate"), exports);
__exportStar(require("./SellerRmtMinimal"), exports);
__exportStar(require("./SellerRmtUpdate"), exports);
__exportStar(require("./SellerUpdate"), exports);
__exportStar(require("./ShippingLabelFormat"), exports);
__exportStar(require("./ShippingLabelRate"), exports);
__exportStar(require("./ShippingLabelRateRequest"), exports);
__exportStar(require("./ShippingLabelRefundStatus"), exports);
__exportStar(require("./ShippingLabelShareRequest"), exports);
__exportStar(require("./SopMinimal"), exports);
__exportStar(require("./TrackingStatus"), exports);
__exportStar(require("./UnclaimedReturnOrderCreate"), exports);
__exportStar(require("./VasApplied"), exports);
__exportStar(require("./public-api"), exports);
__exportStar(require("./SellerDispositionBulkUpdateData"), exports);
__exportStar(require("./PurchaseQcPackageLabelRequest"), exports);
__exportStar(require("./PurchaseRTMPackageLabelRequest"), exports);
__exportStar(require("./PurchaseQcPackageLabelResponse"), exports);
__exportStar(require("./QcPackageDetails"), exports);
__exportStar(require("./QcShipmentStatus"), exports);
__exportStar(require("./BoxName"), exports);
__exportStar(require("./QcShipmentMinimal"), exports);
__exportStar(require("./PackageListResponse"), exports);
__exportStar(require("./RmtDisabledReason"), exports);
__exportStar(require("./ReturnOrderDetail"), exports);
__exportStar(require("./ReturnItemDetail"), exports);
//# sourceMappingURL=index.js.map